import { elementLabels } from '../data';
import type { ElementType } from '../types';
import { ElementIcon } from './ElementIcon';

export function ElementBadge({ element, compact = false }: { element: ElementType; compact?: boolean }) {
  return (
    <span className={`element-badge element--${element.toLowerCase()}`} title={elementLabels[element]}>
      <ElementIcon element={element} size="sm" />{compact ? null : elementLabels[element]}
    </span>
  );
}
